export default __webpack_public_path__ + "static/media/SansWeb-Bold.0b2e7f11.woff2";